import { createRouter, createWebHistory } from "vue-router";

import showInspections from "@/views/InspectionsView.vue";
import Customers from "@/views/CustomersView.vue";
import singleInspection from "@/views/InspectionView.vue";
import singleCustomer from "@/views/CustomerView.vue";
import newCustomer from "@/views/CustomerNewView.vue";

const routes = [
  { path: "/", name: "Inspecties", component: showInspections },
  { path: "/inspection/:id", name: "Inspectiegegevens", component: singleInspection },
  { path: "/customers", name: "Klanten", component: Customers },
  { path: "/customer/:customer_id", name: "Klantgegevens", component: singleCustomer },
  { path: "/customer/new", name: "Nieuwe klant", component: newCustomer },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
